<template>
  <div class="success-page">
    <!-- Header -->
    <div class="viva-page-header">
      <div class="viva-header-content">
        <img src="/viva/viva_logo.svg" alt="Viva" class="viva-logo" />
        <h1 class="viva-page-title">COMPLETE</h1>
      </div>
      <ProfileDropdown
        :student-name="studentName"
        :is-assignment="isAssignment"
      />
    </div>

    <!-- Main Success Interface -->
    <div class="success-interface">
      <div class="viva-container">
        <div class="success-content">

          <!-- Success Message -->
          <h2 class="success-title">VIVA Completed!</h2>

          <!-- Badge with Animation -->
          <div class="success-badge">
            <img src="/viva/badge-background-for-gif.svg" alt="Success Badge" class="badge-background" />
            <img src="/viva/done-hand-stars.gif" alt="Thumbs Up" class="thumbs-up-animation" />
          </div>

          <!-- Coursework completion message -->
          <div v-if="isAssignment" class="completion-message">
            <p class="submission-text">
              Your VIVA has been submitted to your instructor.
            </p>
          </div>

          <!-- Continue Button (admissions only) -->
          <button
            v-if="!isAssignment"
            class="viva-btn viva-btn-green viva-btn-block proceed-btn"
            @click="proceedToSend"
          >
            Send your VIVA
          </button>

          <!-- Issue Reporting Link -->
          <div class="issue-report-prompt">
            <p>
              Anything weird or strange about the questions you were asked? If so, please
              <a href="#" @click="showReportModal = true" class="report-link">Click Here</a> to report it.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Issue Report Modal -->
    <div v-if="showReportModal" class="viva-modal-backdrop" @click="handleModalBackdropClick">
      <div class="viva-modal-content" @click.stop>
        <div class="viva-modal-header">
          <h2>USER REPORT</h2>
        </div>
        <div class="viva-modal-body">
          <div class="report-form">
            <p v-if="!reportSubmitted" class="report-instructions">
              Please use the space below to describe anything strange or weird that may have occurred during your VIVA
            </p>

            <div v-if="!reportSubmitted">
              <textarea
                v-model="issueReport"
                placeholder=""
                class="form-control issue-textarea"
                rows="6">
              </textarea>
              <div class="modal-actions">
                <button
                  @click="submitReport"
                  :disabled="!issueReport.trim()"
                  class="viva-btn viva-btn-green submit-btn"
                >
                  SUBMIT
                </button>
                <button
                  @click="closeReportModal"
                  class="close-link"
                >
                  Close
                </button>
              </div>
            </div>

            <div v-else class="report-submitted">
              <p class="thank-you-message">
                Thank you for reporting that you experienced "{{ submittedReport }}"
                <br><br>
                If you have any further concerns, please email us at
                <a href="mailto:viva@initialview.com">viva@initialview.com</a>
              </p>
              <button
                @click="closeReportModal"
                class="viva-btn viva-btn-green"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '../utils/apiClient.js';
import ProfileDropdown from '../components/ProfileDropdown.vue';
import { getStatusData } from '../utils/statusCache.js';

export default {
  name: 'Success',
  components: {
    ProfileDropdown
  },
  data() {
    return {
      showReportModal: false,
      issueReport: '',
      reportSubmitted: false,
      submittedReport: '',
      studentName: '',
      isAssignment: false
    }
  },
  mounted() {
    const statusData = getStatusData();
    if (statusData) {
      if (statusData.student_name !== undefined) {
        this.studentName = statusData.student_name;
      }
      if (statusData.is_assignment !== undefined) {
        this.isAssignment = statusData.is_assignment;
      }
    }
  },

  methods: {
    proceedToSend() {
      this.$router.push('/send');
    },

    handleModalBackdropClick() {
      // Don't allow closing by clicking backdrop
    },

    async submitReport() {
      if (!this.issueReport.trim()) return;

      try {
        const vparam = sessionStorage.getItem('vparam');
        const payload = {
          note: this.issueReport.trim()
        };

        // Add vparam if coursework student
        if (vparam) {
          payload.vparam = vparam;
        }

        const response = await apiClient.post('/api/viva/student_note/', payload);

        if (response.data.status === 'success') {
          this.submittedReport = this.issueReport.trim();
          this.reportSubmitted = true;
          console.log('Issue report submitted successfully');
        } else {
          throw new Error(response.data.message || 'Failed to submit report');
        }

      } catch (error) {
        console.error('Error submitting issue report:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error submitting report. Please try again.';
        alert(errorMessage);
      }
    },

    closeReportModal() {
      this.showReportModal = false;
      this.issueReport = '';
      this.reportSubmitted = false;
      this.submittedReport = '';
    }
  }
}
</script>

<style scoped>
@import '../styles/viva-classes.css';

.success-page {
  min-height: 100vh;
  background-color: var(--viva-cream);
}

/* Main Layout */
.success-interface {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.success-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Success Title */
.success-title {
  font-size: 48px;
  font-weight: 700;
  color: var(--viva-dark);
  margin-bottom: 25px;
  font-family: 'Playfair Display', serif;
}

/* Badge Container */
.success-badge {
  position: relative;
  display: inline-block;
  /* margin-bottom: 30px; */
}

.badge-background {
  width: 400px;
  height: auto;
  display: block;
}

.thumbs-up-animation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: auto;
}

/* Coursework completion message */
.completion-message {
  margin: 30px 0;
  padding: 20px 30px;
  background: linear-gradient(135deg, var(--viva-cream) 0%, #f8f8f8 100%);
  border: 2px solid var(--viva-green);
  border-radius: 12px;
}

.submission-text {
  font-size: 20px;
  font-weight: 500;
  color: var(--viva-dark);
  margin: 0;
  line-height: 1.5;
}

/* Proceed Button */
.proceed-btn {
  font-size: 22px;
  font-weight: 600;
  padding: 20px 40px;
  margin-bottom: 20px;
  min-width: 300px;
}

/* Issue Report Prompt */
.issue-report-prompt {
  margin-bottom: 25px;
  font-size: 16px;
  color: var(--viva-dark);
  line-height: 1.5;
}

.report-link {
  color: var(--viva-orange);
  text-decoration: none;
  font-weight: 500;
}

.report-link:hover {
  text-decoration: underline;
}

/* Modal Styles */
.report-form {
  text-align: center;
}

.report-instructions {
  font-size: 16px;
  color: var(--viva-dark);
  margin-bottom: 20px;
  line-height: 1.5;
}

.issue-textarea {
  width: 100%;
  border: 2px solid var(--viva-green);
  border-radius: 8px;
  padding: 15px;
  font-size: 16px;
  resize: vertical;
  margin-bottom: 20px;
  font-family: inherit;
}

.issue-textarea:focus {
  outline: none;
  border-color: var(--viva-orange);
  box-shadow: 0 0 5px rgba(245, 176, 65, 0.3);
}

.modal-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.submit-btn {
  font-size: 16px;
  font-weight: 600;
  padding: 12px 30px;
  min-width: 150px;
}

.close-link {
  background: none;
  border: none;
  color: var(--viva-grey);
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}

.close-link:hover {
  color: var(--viva-dark);
}

/* Report Submitted State */
.report-submitted {
  text-align: center;
}

.thank-you-message {
  color: var(--viva-dark);
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 25px;
}

.thank-you-message a {
  color: var(--viva-orange);
  text-decoration: none;
}

.thank-you-message a:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .success-title {
    font-size: 36px;
    margin-bottom: 20px;
  }

  .badge-background {
    width: 300px;
  }

  .thumbs-up-animation {
    width: 120px;
  }

  .success-badge {
    margin-bottom: 25px;
  }

  .proceed-btn {
    font-size: 18px;
    padding: 16px 32px;
    min-width: 280px;
    margin-bottom: 15px;
  }

  .issue-report-prompt {
    font-size: 14px;
    margin-bottom: 20px;
  }
}

@media (max-width: 480px) {
  .success-content {
    padding: 0 15px;
  }

  .success-title {
    font-size: 28px;
  }

  .badge-background {
    width: 200px;
  }

  .thumbs-up-animation {
    width: 80px;
  }

  .proceed-btn {
    font-size: 16px;
    padding: 14px 28px;
    min-width: 250px;
  }
}
</style>